import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { Collapse, NavItem, NavLink } from "reactstrap";
import { Link } from "react-router-dom";
import { Image } from "react-bootstrap";
import { ChevronDown, ChevronRight } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import {
  dashboardSelector,
  updateListViewItemsStatus,
  updateSelectedMenu,
} from "../redux/slices/dashboardSlice";
import { LoggedUserType, SubmenuItemType } from "../utils/Types";
import { loginSelector } from "../redux/slices/loginSlice";
import { LIST_VIEW_ITEM } from "../utils/Constant";

const SubMenu = (props: any) => {
  const [collapsed, setCollapsed] = useState(true);
  const toggle = () => setCollapsed(!collapsed);
  const { icon, title, items, parentKey } = props;
  const dashboardState = useSelector(dashboardSelector);
  const dispatch = useDispatch();
  const user: LoggedUserType = useSelector(loginSelector).user;
  useEffect(() => {
    if (dashboardState.selectedMenu && items) {
      for (let index = 0; index < items.length; index++) {
        if (items[index].route === dashboardState.selectedMenu) {
          setCollapsed(false);
          break;
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dashboardState.selectedMenu]);

  return (
    <div>
      <NavItem
        key={parentKey}
        onClick={toggle}
        className={classNames({ "menu-open": !collapsed })}
      >
        <NavLink className="clearfix">
          <Image src={icon} alt="icon" className="icon" />
          {title}
          {collapsed ? (
            <ChevronRight className="drop-down-icon float-end" />
          ) : (
            <ChevronDown className="drop-down-icon float-end" />
          )}
        </NavLink>
      </NavItem>
      <Collapse
        isOpen={!collapsed}
        navbar
        className={classNames("items-menu", { "mb-1": !collapsed })}
      >
        {items.map((submenuItem: SubmenuItemType, index: number) => (
          <>
            {submenuItem.permission && user.permissions?.includes(submenuItem.permission) && (
              <NavItem
                key={`${parentKey}-${index}`}
                className="pl-4 nav-item-submenu"
              >
                <NavLink
                  tag={Link}
                  to={submenuItem.route}
                  className={`align-middle ${
                    dashboardState.selectedMenu === submenuItem.route
                      ? "nav-selected"
                      : "nav-unselected"
                  }`}
                  onClick={() => {
                    if (
                      submenuItem.route === "view-task" ||
                      submenuItem.route === "view-lead"
                    ) {
                      dispatch(
                        updateListViewItemsStatus(LIST_VIEW_ITEM.LIST_ITEMS)
                      );
                    }
                    dispatch(updateSelectedMenu(submenuItem.route));
                  }}
                >
                  {submenuItem.title}
                </NavLink>
              </NavItem>
            )}
          </>
        ))}
      </Collapse>
    </div>
  );
};

export default SubMenu;
